export default __webpack_public_path__ + "static/media/DLP-β.62db6e3e.svg";